import Vue from 'vue'
import Vuex from 'vuex'

import posts from '@/modules/posts'
import works from '@/modules/works'
import taxo_trabalhos from '@/modules/taxo_trabalhos'

import groups from '@/modules/groups'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    posts,
    works,
    taxo_trabalhos,
    groups,
  },
  state: {
    turnFilterUI: false,
    mobileMenu: false,
    tags: [
      {
          text: 'Branding',
          active: false,
      },
      {
          text: 'Design Gráfico',
          active: false,
      },
      {
          text: 'MKT Digital',
          active: false,
      },
      {
          text: 'Apresentação',
          active: false,
      },
      {
          text: 'Videos',
          active: false,
      },
      {
          text: 'Marketing 360',
          active: false,
      },
      {
          text: 'Propaganda',
          active: false,
      },
      {
          text: 'Endomarketing',
          active: false,
      },
    ],
  },
  mutations: {
    turnTag(state, clickedTag) {

      state.tags.forEach(tag =>
        tag.active = tag.text === clickedTag ? !tag.active : tag.active
      )

    },
    turnOffAllTags(state) {
      state.tags.forEach(tag => tag.active = false)
    },
    turnFilterUI(state, payload) {
      state.turnFilterUI = payload
    },
    turnMobileMenu(state, payload) {
      state.mobileMenu = payload
    },
  },
  actions: {
    turnTag({ commit }, clickedTag) {
      commit('turnTag', clickedTag)
    },
    turnOffAllTags({ commit }) {
      commit('turnOffAllTags')
    },
    turnFilterUI({ commit }, payload) {
      commit('turnFilterUI', payload)
    },
    turnMobileMenu({ commit }, payload) {
      commit('turnMobileMenu', payload)
    },
    // eslint-disable-next-line
    stopScrolling({ commit }, payload) {
      const body = document.querySelector('body')
      payload
        ? body.classList.add('app--stopScrolling')
        : body.classList.remove('app--stopScrolling')
    }
  },
  getters: {
    activatedTags: state => state.tags.filter(tag => tag.active),
    tags: state => state.tags,
    mobileMenu: state => state.mobileMenu,
    activatedTagNames: (state, getters) => getters.activatedTags.map(tag => tag.text)
  }
})
